import { Fragment, PropsWithChildren, ReactElement } from 'react';

import { RouterProvider } from 'react-router-dom';

import { router } from '@/routes';

type AppRouterProviderProps = PropsWithChildren;

export const AppRouterProvider = (
  props: AppRouterProviderProps,
): ReactElement => {
  return (
    <Fragment>
      <RouterProvider router={router} />
      {props.children}
    </Fragment>
  );
};
